import { NAV_LINKS, CONTACT } from "../../data/content";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-brand-primary pb-28 pt-16 text-white lg:pb-16">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-10 border-b border-white/10 pb-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="Home-Szig logó" className="h-14 w-auto" />
              <span className="font-heading text-xl font-extrabold uppercase tracking-tight text-white">
                <span className="text-brand-accent">Home</span>szig
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              Prémium hőszigetelési megoldások 2000 óta — energiatakarékosság és komfort
              lakó- és ipari épületekhez.
            </p>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-white/45">Menü</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => scrollTo(l.href)}
                    className="text-sm text-white/70 transition-colors hover:text-brand-accent"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-white/45">Kapcsolat</h4>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              <li>
                <a href={CONTACT.phoneHref} className="transition-colors hover:text-brand-accent">
                  {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailHref} className="transition-colors hover:text-brand-accent">
                  {CONTACT.email}
                </a>
              </li>
              <li>{CONTACT.hours}</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 pt-8 text-xs text-white/45 sm:flex-row">
          <p>© {new Date().getFullYear()} Home-Szig. Minden jog fenntartva.</p>
          <p>Prémium hőszigetelés · Magyarország</p>
        </div>
      </div>
    </footer>
  );
}
